
export class AbstractSearchArgument {
  constructor () {
    this.page = 1
    this.pageSize = 10
  }
}

export class AbstractFormArgument {
  constructor () {
    this.token = ''
  }
}



// WEBPACK FOOTER //
// ./src/models/global.js